import type { Palette } from "@/api/types";

const STYLE_ID = "kshop-tenant-accent";

/**
 * Apply a tenant's contrast-safe accent tokens (computed by the backend) for both themes.
 * Only --accent-* tokens are overridden; semantic colors stay product-owned. Pass null to reset.
 */
export function applyTenantAccent(palette: Palette | null | undefined): void {
  let style = document.getElementById(STYLE_ID) as HTMLStyleElement | null;
  if (!palette) {
    style?.remove();
    return;
  }
  if (!style) {
    style = document.createElement("style");
    style.id = STYLE_ID;
    document.head.appendChild(style);
  }
  const block = (tokens: Palette["light"]) =>
    [
      `--accent:${tokens.accent}`,
      `--accent-hover:${tokens.accent_hover}`,
      `--accent-fg:${tokens.accent_fg}`,
      `--accent-indicator:${tokens.accent_indicator}`,
      `--accent-text:${tokens.accent_text}`,
      `--accent-subtle:${tokens.accent_subtle}`,
    ].join(";");
  style.textContent = `:root,:root[data-theme="light"]{${block(palette.light)}}:root[data-theme="dark"]{${block(palette.dark)}}`;
}
